// ********************************************************
// Local Storage utillity
// LocalStorage wrapper for saving/loading data with no
// expiration date that will persist after the browser
// window is closed.
// Common data types and javascript object are supported.
// ********************************************************

/*
Examples:
    LocalStorage.save('k1', 'Anders')
    LocalStorage.save('k2', Date.now())
    LocalStorage.save('k3', true)
    LocalStorage.save('k4', 42)
    LocalStorage.save('k5', {a: 'a', b: Date.now(), c: false, c: 42, d: {aa: 43}})

    console.log(LocalStorage.load('k1'))
    console.log(LocalStorage.load('k2'))
    console.log(LocalStorage.load('k3'))
    console.log(LocalStorage.load('k4'))
    console.log(LocalStorage.load('k5'))
*/
import * as Utils from '@/core/utils'

export function save (key, data) {
  // console.log('save:', key, data)

  if (Utils.isObject(data)) {
    localStorage.setItem(key, JSON.stringify(data))
  } else localStorage.setItem(key, data)
}

export function load (key) {
  const str = localStorage.getItem(key)
  // console.log('load:', key, str)
  if (Utils.isJsonString(str)) {
    return JSON.parse(str)
  } else return str
}

export function remove (key) {
  return localStorage.removeItem(key)
}

export function removeAll () {
  return localStorage.clear()
}
